import { useContext, useEffect } from "react";
import { searchContext } from "./context";
import type { OptionParams } from "./types";

export function useRegisterRow({ type, id, cellIds, value, href }: OptionParams) {
  const { send } = useContext(searchContext);
  useEffect(
    function registerOption() {
      let params: OptionParams = { type, id, cellIds, value };
      if (type === "link") {
        params.href = href;
      }
      send({ type: "register_option", params });
      return function unregisterOption() {
        send({ type: "unregister_option", id });
      };
    },
    [type, id, cellIds, value, href, send]
  );
}
